import React from 'react';
import { Grid, Stack } from '@mui/material';
import { Typography, TypographyFontWeightProps, TypographyVariantProps } from '../../atoms/Typography';
import { COLORS } from '../../../configs/colors';
import { LocationSearchItemProps } from './LocationSearchItem.props';
import { IconWrapper, LogoImageGrid, SearchItemContentGrid, SearchItemMainGrid, StyledStack } from './LocationSearchItem.styles';
import { FontStyleProps } from '../../../@types';

export const LocationSearchItem: React.FC<LocationSearchItemProps> = ({
  data,
  isDispatchDestinations,
  isAmLidSearch,
  isAmPidOrSHashSearch,
  canCreateLocation = false,
  isUpdatePartLocation = false
}) => {
  if (canCreateLocation) {
    return (
      <Stack direction="column" spacing={1}>
        <Typography
          variant={TypographyVariantProps.Body2}
          fontWeight={TypographyFontWeightProps.Bold}
        >
          Create New Location
        </Typography>
      </Stack>
    );
  }

  if (isAmLidSearch) {
    return (
      <StyledStack direction="column">
        <Typography textColor={COLORS.Blue} variant={TypographyVariantProps.Body1}>{data.name}</Typography>
        <Typography textColor={COLORS.DarkPurple} variant={TypographyVariantProps.Caption}>{data?.addressOrParentData}</Typography>
        {data?.referenceNo1 && <Typography textColor={COLORS.Gray} variant={TypographyVariantProps.Caption}>{data?.referenceNo1}</Typography>}
        {data.nodeType && <Typography textColor={COLORS.Gray} variant={TypographyVariantProps.Caption}>{data.nodeType.name}</Typography>}
      </StyledStack>
    );
  }

  if (isAmPidOrSHashSearch) {
    return (
      <StyledStack direction="column">
        <Typography textColor={COLORS.Blue} variant={TypographyVariantProps.Body1}>{data.name}</Typography>
        <Typography textColor={COLORS.Black} variant={TypographyVariantProps.Caption}>{data.serial1}</Typography>
      </StyledStack>
    );
  }

  if (isUpdatePartLocation) {
    return (
      <StyledStack direction="column">
        <Typography textColor={COLORS.Blue} variant={TypographyVariantProps.Body1}>{data.name}</Typography>
        <Typography textColor={COLORS.DarkPurple} variant={TypographyVariantProps.Caption}>{data?.addressOrParentData}</Typography>
        {data?.referenceNo1 && <Typography textColor={COLORS.Gray} variant={TypographyVariantProps.Caption}>{data?.referenceNo1}</Typography>}
        {data.nodeType && <Typography textColor={COLORS.Gray} variant={TypographyVariantProps.Caption}>{data.nodeType.name}</Typography>}
        <Typography textColor={COLORS.Black} variant={TypographyVariantProps.Caption}>{data.code}</Typography>
      </StyledStack>
    );
  }

  return (
    <StyledStack direction="column">
      {!isDispatchDestinations ? 
        <SearchItemMainGrid container>
          <LogoImageGrid>
            {!data.clientOrContractData?
              <Grid/>
              :
              data.clientOrContractData?.logoUrl ?
                <IconWrapper
                  src={data.clientOrContractData?.logoUrl}
                  alt={data.clientOrContractData?.code}
                />
                :
                <Typography textColor={COLORS.NavyBlue} variant={TypographyVariantProps.Subtitle1} fontStyle={FontStyleProps.Italic}>
                  {data.clientOrContractData?.code}
                </Typography>
            }
          </LogoImageGrid>
          <SearchItemContentGrid>
            <Typography textColor={COLORS.Blue} variant={TypographyVariantProps.Body1}>{data.name}</Typography>
            <Typography textColor={COLORS.DarkPurple} variant={TypographyVariantProps.Caption}>{data?.addressOrParentData}</Typography>
            {data?.referenceNo1 && <Typography textColor={COLORS.Gray} variant={TypographyVariantProps.Caption}>{data?.referenceNo1}</Typography>}
            <Typography textColor={COLORS.Black} variant={TypographyVariantProps.Caption}>{data.isPartSearch ? '': data.nodeTypeName}</Typography>
          </SearchItemContentGrid>
        </SearchItemMainGrid>
        :
        <>
          <Typography textColor={COLORS.Blue} variant={TypographyVariantProps.Body1}>{data.name}</Typography>
          {data?.addressOrParentData && <Typography textColor={COLORS.DarkPurple} variant={TypographyVariantProps.Caption}>{data?.addressOrParentData}</Typography>}
          {data?.referenceNo1 && <Typography textColor={COLORS.Gray} variant={TypographyVariantProps.Caption}>{data?.referenceNo1}</Typography>}
          {data.nodeTypeName && <Typography textColor={COLORS.Gray} variant={TypographyVariantProps.Caption}>{data.nodeTypeName}</Typography>}
          {data.serviceAddress && <Typography textColor={COLORS.Black} variant={TypographyVariantProps.Caption}>{data.serviceAddress}</Typography>}
          {data.logisticsAddress && <Typography textColor={COLORS.Black} variant={TypographyVariantProps.Caption}>{data.logisticsAddress}</Typography>}
          {data.mainAddress && <Typography textColor={COLORS.Black} variant={TypographyVariantProps.Caption}>{data.mainAddress}</Typography>}
        </>
      }
    </StyledStack>
  );
};